import { useTranslations } from '@vocab/react';
import { Box, Text, TooltipRenderer } from 'braid-design-system';
import { type PropsWithChildren, useId, type FC } from 'react';

import translations from './.vocab';

export const HighFitDisclaimerTooltip: FC<PropsWithChildren> = ({
  children,
}) => {
  const { t } = useTranslations(translations);
  const id = useId();

  return (
    <TooltipRenderer
      id={id}
      placement="bottom"
      tooltip={
        <Text size="small">
          {t(
            "The summary is AI-generated based on info from the applicant's CV, profile and screening question responses. AI-generated content may be inaccurate or inappropriate, so it's your responsibility to review the output. You're responsible for making all hiring decisions.",
          )}
        </Text>
      }
    >
      {({ triggerProps }) => (
        <Box {...triggerProps} data={{ testid: 'high-fit-disclaimer-tooltip' }}>
          {children}
        </Box>
      )}
    </TooltipRenderer>
  );
};
